import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDbq3whp5dV22NiiNy9DTKxg8de_--oyss",
    authDomain: "bashudhara-e-commerce.firebaseapp.com",
    projectId: "bashudhara-e-commerce",
    storageBucket: "bashudhara-e-commerce.appspot.com",
    messagingSenderId: "639842867099",
    appId: "1:639842867099:web:e47aa824d4b9658b5fb33e",
    measurementId: "G-8FJJY30G3L"
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)